export default "__VITE_ASSET__BRua6mY___"